import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import BasicLayout from '@/layouts/BasicLayout';
/**
 * 设置-模块
 */

var setting = {
  path: '/setting',
  redirect: '/setting/index',
  component: BasicLayout,
  children: [{
    path: 'index',
    name: 'Setting',
    component: function component() {
      return import('views/setting/Setting');
    },
    meta: {
      title: '设置'
    }
  }, {
    path: 'resetTranpwd',
    name: 'ResetTranpwd',
    component: function component() {
      return import('views/setting/ResetTranpwd');
    },
    meta: {
      title: '重置交易密码'
    }
  }, {
    path: 'about',
    name: 'About',
    component: function component() {
      return import('views/setting/About');
    },
    meta: {
      title: '联系我们'
    }
  }, {
    path: 'registerProtocol',
    // 用户协议
    name: 'RegisterProtocolPage',
    meta: {
      title: '用户协议'
    },
    component: function component() {
      return import('views/setting/protocol/Register');
    }
  }, {
    path: 'privacyProtocol',
    // 隐私政策
    name: 'PrivacyProtocolPage',
    meta: {
      title: '隐私政策'
    },
    component: function component() {
      return import('views/setting/protocol/Privacy');
    }
  }, {
    path: 'permissions',
    name: 'Permissions',
    component: function component() {
      return import('views/setting/permissions');
    },
    meta: {
      title: '启用权限说明'
    }
  }, {
    path: 'sdk',
    name: 'Sdk',
    component: function component() {
      return import('views/setting/sdk');
    },
    meta: {
      title: '第三方sdk使用说明'
    }
  }, {
    path: '/themeColor',
    name: 'ThemeColor',
    component: function component() {
      return import('views/setting/ThemeColor');
    },
    meta: {
      title: '外观设置'
    }
  }]
};
export default setting;